/* CAFFREY Gel Heel Pad — page behaviour. Launch build (Claude Code, launch agent BUILDER, WORKFLOW-P, 2026-10-08).
   <cf-ghp-gallery>  five photos in one frame: arrows + dots slide the strip (eased, ~0.5 s); swipe on touch; arrow keys;
                     snaps, never pans. Photos 2-5 load after the page has loaded (or at the first touch of the gallery),
                     so they never compete with photo 1 (LCP). Choosing a version shows that version as photo 1 (fade).
   <cf-ghp-buy>      version radios (Men · blue / Women · red) -> the form's hidden [name=id] (+ bubbling change, KIT.md §4a),
                     price, Add to cart state, ?variant= URL, quantity stepper, the heel-only diagram's dot colour.
                     NOTHING preselected (bulletin 6): Add to cart, Shop Pay (guard button) and the kit sticky bar ask for
                     a version first ("Choose Men or Women first.").
   Pair cards (data-ghp-pair): quick adds with a variant select start on "Choose colour"; Add to cart turns on once one
                     is chosen (the kit routine's rule, lead 2026-10-08); a submit with no colour asks for one instead.
   Pattern and lessons: Walk On Air (cf-woa-page.js). Safe to load more than once (defer). No dependencies.
   prefers-reduced-motion: instant slides and swaps. */
(function () {
  if (window.CfGhpPage) return;
  window.CfGhpPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* The Klaviyo pop-up is hidden on this page (cf-ghp-page.css); Klaviyo still adds its scroll lock to <body> while it
     thinks the pop-up is open, so release it whenever it appears (Walk On Air precedent). */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------------- gallery ---------------- */
  class GhpGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-ghp-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ghp-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-ghp-dot]'));
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      var nav = this.querySelector('[data-ghp-nav]');
      if (nav) nav.hidden = false;
      this.setAttribute('data-enhanced', '');
      var prev = this.querySelector('[data-ghp-prev]');
      var next = this.querySelector('[data-ghp-next]');
      if (prev) prev.addEventListener('click', function () { self.warm(); self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.warm(); self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.warm(); self.go(i); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.warm();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking || self._raf) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          self.mark(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      var later = function () { setTimeout(function () { self.warm(); }, 300); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { self.addEventListener(ev, function () { self.warm(); }, { once: true, passive: true }); });
      window.addEventListener('resize', function () {
        /* keep the current photo in place when the frame changes size (rotation, desktop resize) */
        if (self._raf) return;
        self.track.scrollLeft = self.index * self.track.clientWidth;
      }, { passive: true });
    }
    /* photos 2-5: srcset before src, so the browser downloads one file at the right width */
    warm() {
      if (this._warm) return;
      this._warm = true;
      this.slides.forEach(function (s) {
        var img = s.querySelector('img[data-ghp-src]');
        if (!img) return;
        var set = img.getAttribute('data-ghp-srcset');
        if (set) img.setAttribute('srcset', set);
        img.setAttribute('src', img.getAttribute('data-ghp-src'));
        img.removeAttribute('data-ghp-src');
        img.removeAttribute('data-ghp-srcset');
      });
    }
    go(i, instant) {
      var n = this.slides.length;
      if (!n || !this.track) return;
      i = ((i % n) + n) % n;
      this.mark(i);
      var self = this, track = this.track;
      var from = track.scrollLeft, to = i * track.clientWidth;
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      if (instant || reduced() || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
      var dur = Math.min(800, 420 + 110 * Math.abs(to - from) / (track.clientWidth || 1));
      var t0 = null;
      track.style.scrollSnapType = 'none';
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (to - from) * e;
        if (t < 1) { self._raf = requestAnimationFrame(step); return; }
        self._raf = null;
        track.scrollLeft = to;
        track.style.scrollSnapType = '';
      };
      this._raf = requestAnimationFrame(step);
    }
    mark(i) {
      if (i === this.index && this._marked) return;
      this._marked = true;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      var k = this.index;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === k)); });
    }
    /* Photo 1 always shows the chosen version and photo 2 the other one: swap the two photos (they share the exact same
       framing on the same canvas, so only the oval's colour changes) and fade the new photo 1 in. */
    showVersion(key, byUser) {
      var s0 = this.slides[0], s1 = this.slides[1];
      if (!key || !s0 || !s1) return;
      if (s0.getAttribute('data-ghp-key') !== key && s1.getAttribute('data-ghp-key') === key) {
        this.warm();
        var a = s0.querySelector('img'), b = s1.querySelector('img');
        if (a && b) {
          s0.insertBefore(b, s0.firstChild);
          s1.insertBefore(a, s1.firstChild);
          s1.setAttribute('data-ghp-key', s0.getAttribute('data-ghp-key'));
          s0.setAttribute('data-ghp-key', key);
          if (byUser && !reduced()) {
            b.classList.add('is-fading');
            void b.offsetWidth;
            requestAnimationFrame(function () { b.classList.remove('is-fading'); });
          }
        }
      }
      if (byUser && this.index !== 0) this.go(0);
    }
  }

  /* ---------------- buy box: version radios -> kit-compatible product form ---------------- */
  class GhpBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.qty = this.form.querySelector('input[name="quantity"]');
      this.msg = this.querySelector('[data-ghp-msg]');
      this.box = this.querySelector('[data-ghp-versions]');
      this.guard = this.querySelector('[data-ghp-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-ghp-version]'));
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-ghp-version]')) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-ghp-qty]') : null;
        if (!b || !self.qty) return;
        var min = parseInt(self.qty.min, 10) || 1;
        self.qty.value = Math.max(min, (parseInt(self.qty.value, 10) || min) + Number(b.getAttribute('data-ghp-qty')));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no version chosen, a
         click anywhere in the payment block (Enter on the link included) asks for a version instead. */
      var pay = this.querySelector('[data-ghp-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-ghp-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    gallery() { return document.querySelector('cf-ghp-gallery'); }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) Array.prototype.forEach.call(document.querySelectorAll('[data-ghp-price]'), function (el) { el.textContent = price; });
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      var swatch = r.getAttribute('data-swatch');
      if (swatch) document.documentElement.style.setProperty('--cf-ghp-swatch', swatch);
      var g = this.gallery();
      if (g && typeof g.showVersion === 'function') g.showVersion(r.getAttribute('data-key'), byUser);
      this.clearAsk();
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* "Choose Men or Women first.": message under the versions, versions highlighted, scrolled into view, first focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.error || '';
        this.msg.hidden = false;
      }
      if (this.box) {
        this.box.classList.remove('is-asking');
        void this.box.offsetWidth; /* restart the highlight when asked again */
        this.box.classList.add('is-asking');
        var rect = this.box.getBoundingClientRect();
        if (rect.top < 72 || rect.bottom > window.innerHeight - 96) {
          this.box.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.box) this.box.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it would read "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      var choosing = !r && !!this.firstAvailable();
      if (st.classList.contains('cf-ghp-sticky--choose') !== choosing) st.classList.toggle('cf-ghp-sticky--choose', choosing);
      if (r) {
        var want = r.getAttribute('data-title') || '';
        if (v && want && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && this.dataset.add && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && this.dataset.choose && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- pair cards: no colour preselected ---------------- */
  function pairAsk(form, sel) {
    var msg = form.querySelector('[data-ghp-pair-msg]');
    if (msg) {
      msg.textContent = msg.getAttribute('data-text') || '';
      msg.hidden = false;
    }
    sel.classList.remove('is-asking');
    void sel.offsetWidth;
    sel.classList.add('is-asking');
    try { sel.focus({ preventScroll: false }); } catch (e) { sel.focus(); }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest || !f.closest('[data-ghp-pair]')) return;
    var sel = f.querySelector('select[data-ghp-pair-select]');
    if (!sel || sel.value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pairAsk(f, sel);
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('select[data-ghp-pair-select]')) return;
    sel.classList.remove('is-asking');
    var msg = sel.form ? sel.form.querySelector('[data-ghp-pair-msg]') : null;
    if (msg && sel.value) { msg.hidden = true; msg.textContent = ''; }
    var btn = sel.form ? sel.form.querySelector('button[name="add"]') : null;
    if (btn && sel.value) { btn.disabled = false; btn.removeAttribute('aria-disabled'); }
  });

  [['cf-ghp-gallery', GhpGallery], ['cf-ghp-buy', GhpBuy]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
